'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("SaisieBudgetDeplacementPopinController", function ($scope, $http, $translate, $session, $q, lovService, contextService, budgetService) {
  var reloadContext = function reloadContext() {
    contextService.refreshData();
  };
  var compte = $session.getCompte();
  var parentBudget = $scope.parent;
  var originalBudget = $scope.originalBudget = $scope.budget;
  var budget = $scope.budget = angular.copy(originalBudget);
  var sep = function sep(depth) {
    if (depth === 0) {
      return "";
    } else {
      var _spaces = String.fromCharCode(160) + String.fromCharCode(160) + String.fromCharCode(160) + String.fromCharCode(160);
      var spaces = _spaces;
      for (var i = 1; i < depth; i++) {
        spaces += _spaces;
      }
      return spaces;
    }
  };
  $http.get('/rest/budgets/possibilites-deplacements/' + budget.id).then(function (response) {
    var budgetsDeplacement = budgetService.flattenTree(response.data);
    $scope.budgetsDeplacement = _.each(budgetsDeplacement, function (b) {
      return b.nom = sep(b.depth) + " " + b.nom;
    });
  });
  $scope.saveBudget = function () {
    // saving
    var savePromise = $http.post("/rest/budgets/deplace-budget?budgetId=" + budget.id + "&newParentId=" + budget.parentId);
    savePromise.then(function (response) {
      var validation = response.data;
      reloadContext();
      $scope.$close(budget);
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/budget/gestionBudgets/budgetDeplacementPopin.js
// module id = 2681
// module chunks = 13